export const MANAGE_USERS_ACCOUNT = 'Manage the users account'
export const MANAGE_PAIR = 'Manage pair'
export const MANAGE_TOKEN = 'Manage token'
export const MANAGE_ADMINS = 'Manage admins'
export const MANAGE_SWAP = 'Manage swap'
export const MANAGE_FEE = 'Manage fee'
export const MANAGE_BDLTY_TOKEN = 'Manage BDLTY token'
export const MANAGE_QUIZ = 'Manage Quiz'
export const ACCEPT_ALL_PERMISSIONS = 'Accept all permissions'

export const ALL_EXISTING_ROLES_AMOUNT = 7

export const INITIAL_PERMISSIONS_STATE = {
    'Accept all permissions': false,
    'Manage the users account': false,
    'Manage admins': false,
    'Manage swap': false,
    'Manage token': false,
    'Manage fee': false,
    'Manage pair': false,
    'Manage BDLTY token': false,
    'Manage Quiz': false,
}

export const ACCEPT_ALL_ROLES = {
    'Accept all permissions': true,
    'Manage the users account': true,
    'Manage admins': true,
    'Manage swap': true,
    'Manage token': true,
    'Manage fee': true,
    'Manage pair': true,
    'Manage BDLTY token': true,
    'Manage Quiz': true,
}
